// Blocking profile-completion gate for CSOC students inside School of Chess.
//
// Deliberately NOT the global SlideModal. That renders through an RN Modal,
// which covers the entire viewport — including the permanent left menu rail and
// the mobile header — so a non-dismissable one strands the user with nowhere to
// go. This overlay is absolutely positioned inside the School of Chess screen
// instead, so it covers exactly the scene: the left menu and the header stay
// live and the user can always navigate away.
//
// There is no close affordance. The two ways past it are to finish the profile
// or to leave the section.

import React from 'react';
import {StyleSheet, View} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import ChecklistBody from '@/Components/OnboardingChecklistSheet/ChecklistBody';
import {CSOC_GATE_STEPS} from './useCsocProfileNudge';

export default function CsocProfileGate() {
  const navigation = useNavigation<any>();

  return (
    <View style={styles.overlay}>
      <View style={styles.card}>
        <CCText fontSize={17} fontWeight="semibold" style={styles.title}>
          Finish your profile to continue
        </CCText>
        <CCText fontSize={12.5} style={styles.sub}>
          School of Chess needs these to set up your classes and leaderboard.
        </CCText>
        <ChecklistBody
          stepKeys={CSOC_GATE_STEPS}
          onNavigate={route => route && navigation.navigate(route)}
          footerNote="You can still use the menu to go elsewhere."
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    // Absolute inside the School of Chess root View — not 'fixed' — so the app
    // chrome outside this screen is untouched.
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(38,35,34,0.55)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    zIndex: 999,
  },
  card: {
    backgroundColor: CCColors.White,
    borderRadius: 16,
    paddingHorizontal: 20,
    paddingTop: 18,
    paddingBottom: 12,
    maxWidth: 400,
    width: '100%',
    shadowColor: '#000',
    shadowOpacity: 0.22,
    shadowRadius: 24,
    shadowOffset: {width: 0, height: 10},
  },
  title: {
    color: CCColors.Primary.Brown,
  },
  sub: {
    color: CCColors.TextColor.GreyText,
    marginTop: 4,
    marginBottom: 4,
  },
});
